/**
 * UTF-8 Encoding.
 *
 * @group Utils
 *
 * @beta
 */
export const UTF_8 = 'utf-8';
